import { Badge, Group } from '@mantine/core';
import { IconFlag, IconFlagFilled } from '@tabler/icons-react';
import { Button } from '../../../components/common/Button';
import classes from '../css/QuestionHeader.module.css';

const TYPE_LABELS: Record<string, string> = {
  single: 'Single Choice',
  match_pair: 'Match Pair',
};

interface Props {
  number: number;
  marks: number;
  type: string;
  flagged?: boolean;
  onFlagClick?: () => void;
}

export function QuestionHeader({ number, marks, type, flagged = false, onFlagClick }: Props) {
  const typeLabel = TYPE_LABELS[type] ?? type;

  return (
    <Group justify="space-between" wrap="nowrap">
      <Group gap="sm">
        <div className={classes.circle}>{number}</div>
        <Badge className={classes.badge}>{marks} Mark</Badge>
        <Badge className={classes.typeBadge}>{typeLabel}</Badge>
      </Group>
      <Button
        className={`${classes.flagBtn} ${flagged ? classes.flagged : ''}`}
        onClick={onFlagClick}
        aria-label={flagged ? 'Unflag question' : 'Flag for review'}
      >
        {flagged ? <IconFlagFilled size={22} /> : <IconFlag size={22} />}
      </Button>
    </Group>
  );
}
